module.exports = __webpack_public_path__ + "img/send.54b29d11.svg";